import { Flex, Image, Text, Heading } from "@chakra-ui/react"

const Benefit = ({ image, text, title }) => {
  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      borderRadius="4px"
      padding="8px"
      margin={["8px", "8px", "16px", "24px"]}
      width="250px"
    >
      <Image src={image} marginTop="8px" />
      <Heading marginTop="16px" size="md" as="h5" textAlign="center">
        {title}
      </Heading>
      <Text fontSize="md" marginTop="16px" textAlign="center">
        {text}
      </Text>
    </Flex>
  )
}

export default Benefit
